export enum EVENT_ENUM {
    IS_SIDE_NAV_OPEN = "isSideNavOpen",
    OPEN_INFO_MODAL = "openInfoModal",
    LOGOUT = "logout",
    PROFILE_CHANGE = "kundaliProfileChagne"
}

export enum STORAGE_ENUM {
    TOKEN = "mytruthstar_token",
    CURRENT_KUNDALI_PROFILE = "currentKundaliProfile",
    NUMEROLOGY_CURRENT_OPTION_ID = "numerologyCurrentOptionId"
}